module.exports = __webpack_public_path__ + "img/img76.a12b74c2.png";